module.exports = __webpack_public_path__ + "fransa mutfak 12.jpg?95e4049b4d35fb4af81bbff2f9c34e9e";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa mutfak 12.jpg
// module id = 339
// module chunks = 0